import SubfactorHealthCard from './SubfactorHealthCard'

export {SubfactorHealthCard}
export default SubfactorHealthCard
